import { ref } from "vue";
import firebase from "../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  setDoc,
  Timestamp,
  doc,
  orderBy,
} from "firebase/firestore";

const getMessages = () => {
  const messages = ref([]);
  const uid = ref(null);
  const doctorId = firebase.firebaseAuth.currentUser.uid;

  const loadUserMessages = async (userId) => {
    if (uid.value !== userId) {
      uid.value = userId;
      messages.value = [];

      const q = query(
        collection(firebase.db, "notifications"),
        where("doctorID", "==", doctorId),
        where("userID", "==", userId),
        orderBy("timestamp")
      );
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        messages.value.push(doc.data());
      });
    }
  };

  const addUserMessage = async (uid, message) => {
    const newMessageRef = doc(collection(firebase.db, "notifications"));

    const newMessage = {
      doctorID: doctorId,
      id: newMessageRef.id,
      isFavourite: false,
      isRead: false,
      messageBody: message,
      timestamp: Timestamp.fromDate(new Date()),
      userID: uid,
    };

    messages.value.push(newMessage);
    await setDoc(newMessageRef, newMessage);
    console.log("messages", messages.value);
  };

  return { messages, loadUserMessages, addUserMessage };
};
export default getMessages;
